export const RATING_REQUEST = "@@home/RATING_REQUEST"
export const RATING_SUCCESS = "@@home/RATING_SUCCESS"
export const RATING_FAILED = "@@home/RATING_FAILED"

export const TRACK_REQUEST = "@@home/TRACK_REQUEST"